import { render, staticRenderFns } from "./LinksItem.vue?vue&type=template&id=7489ca2a&scoped=true&"
import script from "./LinksItem.vue?vue&type=script&lang=js&"
export * from "./LinksItem.vue?vue&type=script&lang=js&"
import style0 from "./LinksItem.vue?vue&type=style&index=0&id=7489ca2a&prod&scoped=true&lang=css&"
import style1 from "./LinksItem.vue?vue&type=style&index=1&id=7489ca2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7489ca2a",
  null
  
)

export default component.exports